import React, { useRef, useState,useEffect } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import MediaModel from "../MediaUpload/MediaModel";

import { hasPermission } from "../../../helpers/permission";

import toast from "react-hot-toast";
const Banner = () => {
   const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  
  const imageInputRef = useRef(null);

  const [isEditMain, setEditMain] = useState(false);
  const [heroBannerData, setHeroBannerData] = useState(null);

  const [uploadedImages, setUploadedImages] = useState(null);
  const [imageModel, setImageModel] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [error, setError] = useState(null);
  const [mainImage, setMainImage] = useState([]);
  const [mainBannerData, setmainBannerData] = useState([]);
  const [ProductBannerData, setProductBannerData] = useState([]);
  const [productSidebarBannerData, setproductSidebarBannerData] = useState([]);
  const [mainSideMiniBannerData, setmainSideMiniBannerData] = useState([]);
  const [HomeAdsBannerData, setHomeAdsBannerData] = useState([]);

  const [categoryBannerData, setCategoryBannerData] = useState([]);
  const [subcategoryBannerData, setSubcategoryBannerData] = useState([]);
  const [ProductTopBannerData, setProductTopBannerData] = useState([]);
  
  const toggleImageModal = () => {
    setImageModel(!imageModel);
    setSelectedImage([]);
  };

  const handleUploadImage = (image) => {
    if (image) {
      setUploadedImages([imgurl + image[0].fileurl]);
      formik.setFieldValue("image", image[0].fileurl);
    }
    toggleImageModal();
    setSelectedImage(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const newImage = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
      setUploadedImages([imgurl + newImage]);
    }
  };

  const [isEditSide, setEditSide] = useState(false);


  const handleEditClick = (banner) => {
    setHeroBannerData(banner);
    if (banner.banner_img) {
      setUploadedImages([imgurl + banner.banner_img]);
    } else {
      setUploadedImages(null);
    }
    setEditMain(true);
  };

  const handleMainClick = (banner) => {
    setHeroBannerData(banner);
    setEditSide(true);
  };

  const fetchmainBannerData = async () => {
      try {
        setError(null); // Reset error before fetching
        const response = await fetch(`${baseurl}/admin/content/mainbanners`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setmainBannerData(data);
      } catch (error) {
        setError(error.message);
      }
    };
  
    const fetchCategoryBannerData = async () => {
      try {
        setError(null); // Reset error before fetching
        const response = await fetch(`${baseurl}/admin/content/categorybanners`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCategoryBannerData(data);
      } catch (error) {
        setError(error.message);
      }
    };

    const fetchSubcategoryBannerData = async () => {
      try {
        setError(null); // Reset error before fetching
        const response = await fetch(`${baseurl}/admin/content/subcategorybanners`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setSubcategoryBannerData(data);
      } catch (error) {
        setError(error.message);
      }
    };

    const fetchSideMiniBannerData = async () => {
      try {
        setError(null); // Reset error before fetching
        const response = await fetch(`${baseurl}/admin/content/sideminibanners`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setmainSideMiniBannerData(data);
      } catch (error) {
        setError(error.message);
      }
    };
  
    const fetchHomeAdsBannerData = async () => {
      try {
        setError(null); // Reset error before fetching
        const response = await fetch(`${baseurl}/admin/content/homeadsbanners`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setHomeAdsBannerData(data);
      } catch (error) {
        setError(error.message);
      }
    };

    const fetchProductBannerData = async () => {
      try {
        setError(null); // Reset error before fetching
        const response = await fetch(`${baseurl}/admin/content/productbanners`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setProductBannerData(data);
      } catch (error) {
        setError(error.message);
      }
    };

    const fetchproductSidebarBannerData = async () => {
      try {
        setError(null); // Reset error before fetching
        const response = await fetch(`${baseurl}/admin/content/productsidebarbanners`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setproductSidebarBannerData(data);
      } catch (error) {
        setError(error.message);
      }
    };
  
    useEffect(() => {
      fetchmainBannerData();
      fetchSideMiniBannerData();
      fetchProductBannerData();
      fetchHomeAdsBannerData();
      fetchproductSidebarBannerData();
      fetchSubcategoryBannerData();
      fetchCategoryBannerData();
    }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
       id: (heroBannerData && heroBannerData.id) || "",
      type:(heroBannerData && heroBannerData.type) || "Main Banner",
      mainBannerLink: (heroBannerData && heroBannerData.link) || "",
      image: (heroBannerData && heroBannerData.banner_img) || "",
      status: (heroBannerData && heroBannerData.status) || "Active",
    },
    validationSchema: Yup.object({
      mainBannerLink: Yup.string().required("Please enter the link"),
      // image: Yup.array().min(1, "Please upload at least one image"),
      image: Yup.mixed().test(
        "fileSelected",
        "Please select an image",
        () => uploadedImages && uploadedImages.length > 0
      ),
      status: Yup.string().required("Please select the status"),
    }),
    onSubmit: async (values) => {
          const { id, mainBannerLink, image,type, status } = values;
      
          try {
            let response;
              response = await fetch(baseurl+`/admin/content/banners/${id}`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  banner_img: image,
                  link: mainBannerLink,
                  status : status,
                }),
              });
              if (!response.ok) {
                throw new Error("Error updating user");
              }
              toast.success('Banner updated successfully!', 'success');
                fetchmainBannerData();
                fetchSideMiniBannerData();
                fetchProductBannerData();
                fetchHomeAdsBannerData();
                fetchproductSidebarBannerData();
              setEditMain(false);
              
              
          } catch (error) {
            console.error(error);
            // Handle any errors, show an error message if needed
          }
        },
  });

  document.title = "Banner Section | Vekart";

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Banner" breadcrumbItem="Banner Section" />

          {/* Hero Main Full Banner */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-3">Main Banner (1200px * 600px)</CardTitle>

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Banner Image</th>
                          <th>Banner Link</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mainBannerData?.map((data, index) => (
                          <tr key={index}>
                            <th scope="row">{data?.id}</th>
                            <td>
                              <img
                                className="rounded"
                                alt="150x150"
                                width="150"
                                src={`${imgurl}${data?.banner_img}`}
                                data-holder-rendered="true"
                              />
                            </td>
                            <td className="text-primary">
                              {data?.link}
                            </td>
                            <td>{data?.status}</td>
                            <td>
                              <div className="d-flex gap-3">
                                {hasPermission("contents.banner.edit") && (
                                <Link
                                  to="#"
                                  className="text-success"
                                  onClick={() => handleEditClick(data)}
                                >
                                  <i
                                    className="mdi mdi-pencil font-size-18"
                                    id="edittooltip"
                                  />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="edittooltip"
                                  >
                                    Edit
                                  </UncontrolledTooltip>
                                </Link>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Side Hero Mini Banner */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-3">
                    Main Side Mini Banner (1200px * 600px)
                  </CardTitle>

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Banner Image</th>
                          <th>Banner Link</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mainSideMiniBannerData?.map((data, index) => (
                          <tr className="index">
                            <th scope="row">{data?.id}</th>
                            <td>
                              <img
                                className="rounded"
                                alt="150x150"
                                width="150"
                                src={`${imgurl}${data?.banner_img}`}
                                
                                data-holder-rendered="true"
                              />
                            </td>
                            <td className="text-primary">
                              {data?.link}
                            </td>
                            <td>{data?.status}</td>
                            <td>
                              <div className="d-flex gap-3">
                                {hasPermission("contents.banner.edit") && (
                                <Link
                                  to="#"
                                  className="text-success"
                                  onClick={() => handleEditClick(data)}
                                >
                                  <i
                                    className="mdi mdi-pencil font-size-18"
                                    id="edittooltip"
                                  />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="edittooltip"
                                  >
                                    Edit
                                  </UncontrolledTooltip>
                                </Link>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Detail Page Banner */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-3">
                    Product Detail Page Banner (1350px * 350px)
                  </CardTitle>

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Banner Image</th>
                          <th>Banner Link</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ProductBannerData?.map((data, index) => (
                          <tr className="index">
                            <th scope="row">{data?.id}</th>
                            <td>
                              <img
                                className="rounded"
                                alt="150x150"
                                width="150"
                                src={`${imgurl}${data?.banner_img}`}
                                
                                data-holder-rendered="true"
                              />
                            </td>
                            <td className="text-primary">{data?.link}</td>
                            <td>{data?.status}</td>
                            <td>
                              <div className="d-flex gap-3">
                                {hasPermission("contents.banner.edit") && (
                                <Link
                                  to="#"
                                  className="text-success"
                                  onClick={() => handleEditClick(data)}
                                >
                                  <i
                                    className="mdi mdi-pencil font-size-18"
                                    id="edittooltip"
                                  />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="edittooltip"
                                  >
                                    Edit
                                  </UncontrolledTooltip>
                                </Link>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Category Page Banner */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-3">
                    Category Banner (1350px * 350px)
                  </CardTitle>

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Banner Image</th>
                          <th>Banner Link</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {categoryBannerData?.map((data, index) => (
                          <tr className="index">
                            <th scope="row">{data?.id}</th>
                            <td>
                              <img
                                className="rounded"
                                alt="150x150"
                                width="150"
                                src={`${imgurl}${data?.banner_img}`}
                                
                                data-holder-rendered="true"
                              />
                            </td>
                            <td className="text-primary">{data?.link}</td>
                            <td>{data?.status}</td>
                            <td>
                              <div className="d-flex gap-3">
                                {hasPermission("contents.banner.edit") && (
                                <Link
                                  to="#"
                                  className="text-success"
                                  onClick={() => handleEditClick(data)}
                                >
                                  <i
                                    className="mdi mdi-pencil font-size-18"
                                    id="edittooltip"
                                  />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="edittooltip"
                                  >
                                    Edit
                                  </UncontrolledTooltip>
                                </Link>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Subcategory Banner */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-3">
                    Subcategory Banner (1350px * 350px)
                  </CardTitle>

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Banner Image</th>
                          <th>Banner Link</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {subcategoryBannerData?.map((data, index) => (
                          <tr className="index">
                            <th scope="row">{data?.id}</th>
                            <td>
                              <img
                                className="rounded"
                                alt="150x150"
                                width="150"
                                src={`${imgurl}${data?.banner_img}`}
                                
                                data-holder-rendered="true"
                              />
                            </td>
                            <td className="text-primary">{data?.link}</td>
                            <td>{data?.status}</td>
                            <td>
                              <div className="d-flex gap-3">
                                {hasPermission("contents.banner.edit") && (
                                <Link
                                  to="#"
                                  className="text-success"
                                  onClick={() => handleEditClick(data)}
                                >
                                  <i
                                    className="mdi mdi-pencil font-size-18"
                                    id="edittooltip"
                                  />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="edittooltip"
                                  >
                                    Edit
                                  </UncontrolledTooltip>
                                </Link>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Home page Ads Banner */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-3">
                    Home Page Ads Banner (1350px * 350px)
                  </CardTitle>

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Banner Image</th>
                          <th>Banner Link</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {HomeAdsBannerData?.map((data, index) => (
                          <tr className="index">
                            <th scope="row">{data?.id}</th>
                            <td>
                              <img
                                className="rounded"
                                alt="150x150"
                                width="150"
                                src={`${imgurl}${data?.banner_img}`}
                                
                                data-holder-rendered="true"
                              />
                            </td>
                            <td className="text-primary">{data?.link}</td>
                            <td>{data?.status}</td>
                            <td>
                              <div className="d-flex gap-3">
                                {hasPermission("contents.banner.edit") && (
                                <Link
                                  to="#"
                                  className="text-success"
                                  onClick={() => handleEditClick(data)}
                                >
                                  <i
                                    className="mdi mdi-pencil font-size-18"
                                    id="edittooltip"
                                  />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="edittooltip"
                                  >
                                    Edit
                                  </UncontrolledTooltip>
                                </Link>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Product Sidebar Banner */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-3">
                    Product Sidebar Banner (500px * 350px)
                  </CardTitle>

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Banner Image</th>
                          <th>Banner Link</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productSidebarBannerData?.map((data, index) => (
                          <tr className="index">
                            <th scope="row">{data?.id}</th>
                            <td>
                              <img
                                className="rounded"
                                alt="150x150"
                                width="150"
                                src={`${imgurl}${data?.banner_img}`}
                                
                                data-holder-rendered="true"
                              />
                            </td>
                            <td className="text-primary">{data?.link}</td>
                            <td>{data?.status}</td>
                            <td>
                              <div className="d-flex gap-3">
                                <Link
                                  to="#"
                                  className="text-success"
                                  onClick={() => handleEditClick(data)}
                                >
                                  <i
                                    className="mdi mdi-pencil font-size-18"
                                    id="edittooltip"
                                  />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="edittooltip"
                                  >
                                    Edit
                                  </UncontrolledTooltip>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Modal for Edit Main Banner*/}
          <Modal
            isOpen={isEditMain}
            toggle={handleEditClick}
            backdrop="static"
            keyboard={false}
          >
            <ModalHeader toggle={() => setEditMain(false)} tag="h4">
              Edit Main Banner
            </ModalHeader>
            <ModalBody>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Banner Link</Label>
                      <Input
                        name="mainBannerLink"
                        type="text"
                        placeholder="Insert Banner Link"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mainBannerLink || ""}
                        invalid={
                          formik.touched.mainBannerLink &&
                          formik.errors.mainBannerLink
                            ? true
                            : false
                        }
                      />
                      {formik.touched.mainBannerLink &&
                      formik.errors.mainBannerLink ? (
                        <FormFeedback type="invalid">
                          {formik.errors.mainBannerLink}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
              
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Banner Image</Label>
                      <Input
                        name="image"
                        type="file"
                        accept="image/jpeg, image/png"
                        onChange={handleImageChange}
                        innerRef={imageInputRef}
                        style={{ display: "none" }}
                        invalid={
                          formik.touched.image && formik.errors.image
                            ? true
                            : false
                        }
                      />
                      <div
                        className="custom-file-button"
                        onClick={toggleImageModal}
                      >
                        <i
                          className="bx bx-cloud-upload me-2"
                          style={{ fontSize: "25px" }}
                        ></i>
                        Choose File
                      </div>
                      {formik.errors.image && formik.touched.image ? (
                        <FormFeedback type="invalid" className="d-block">
                          {formik.errors.image}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  {uploadedImages && (
                    <Card className="mt-1 mb-3 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="d-flex justify-content-between align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="100"
                              width="100"
                              className="avatar-md rounded bg-light"
                              alt="images"
                              src={uploadedImages}
                            />
                          </Col>
                          <Col className="col-auto">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => {
                                setUploadedImages(null);
                              }}
                            >
                              Delete
                            </button>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Status</Label>
                      <Input
                        name="status"
                        type="select"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status || ""}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Input>
                      {formik.touched.status && formik.errors.status ? (
                        <FormFeedback type="invalid">
                          {formik.errors.status}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="success">
                        Update
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>

          {/* Modal for Edit Main Side Banner*/}
          <Modal
            isOpen={isEditSide}
            toggle={handleMainClick}
            backdrop="static"
            keyboard={false}
          >
            <ModalHeader toggle={() => setEditSide(false)} tag="h4">
              Edit Main Side Mini Banner
            </ModalHeader>
            <ModalBody>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Banner Link</Label>
                      <Input
                        name="mainBannerLink"
                        type="text"
                        placeholder="Insert Banner Link"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mainBannerLink || ""}
                        invalid={
                          formik.touched.mainBannerLink &&
                          formik.errors.mainBannerLink
                            ? true
                            : false
                        }
                      />
                      {formik.touched.mainBannerLink &&
                      formik.errors.mainBannerLink ? (
                        <FormFeedback type="invalid">
                          {formik.errors.mainBannerLink}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
             
                  <Col className="col-12">
                    fileInputRef
                    <div className="mb-3">
                      <Label className="form-label">Banner Image</Label>
                      <Input
                        name="image"
                        type="file"
                        accept="image/jpeg, image/png"
                        onChange={handleImageChange}
                        innerRef={imageInputRef}
                        style={{ display: "none" }}
                        invalid={
                          formik.touched.image && formik.errors.image
                            ? true
                            : false
                        }
                      />
                      <div
                        className="custom-file-button"
                        onClick={toggleImageModal}
                      >
                        <i
                          className="bx bx-cloud-upload me-2"
                          style={{ fontSize: "25px" }}
                        ></i>
                        Choose File
                      </div>
                      {formik.errors.image && formik.touched.image ? (
                        <FormFeedback type="invalid" className="d-block">
                          {formik.errors.image}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  {uploadedImages && (
                    <Card className="mt-1 mb-3 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="d-flex justify-content-between align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="100"
                              width="100"
                              className="avatar-md rounded bg-light"
                              alt="images"
                              src={uploadedImages}
                            />
                          </Col>
                          <Col className="col-auto">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => {
                                setUploadedImages(null);
                              }}
                            >
                              Delete
                            </button>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Status</Label>
                      <Input
                        name="status"
                        type="select"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status || ""}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Input>
                      {formik.touched.status && formik.errors.status ? (
                        <FormFeedback type="invalid">
                          {formik.errors.status}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="success">
                        Update
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>

          {/* Modal for select image */}
          <MediaModel
            imageModel={imageModel}
            toggleModal={toggleImageModal}
            handleUploadImage={handleUploadImage}
            selectedImage={selectedImage}
            setSelectedImage={setSelectedImage}
          />
        </Container>
      </div>
    </>
  );
};

export default withRouter(Banner);
